import en from './en-US';
import ru from './ru-RU';
import uk from './uk-UA';

const messages = {
    ...en,
    ...ru,
    ...uk,
};

export default messages;
